import { Check, Users } from "lucide-react";
import { VEHICLE_IMAGES } from "@/lib/booking";
import { money } from "@/lib/format";

export function VehicleCard({ vehicle, selected, hourly, onSelect }) {
  return (
    <button
      type="button"
      onClick={() => onSelect(vehicle.id)}
      data-testid={`vehicle-card-${vehicle.id}`}
      aria-pressed={selected}
      className={`group relative w-[230px] shrink-0 snap-start overflow-hidden rounded-2xl border bg-surface text-left transition-[border-color,transform,box-shadow] duration-300 hover:-translate-y-0.5 sm:w-auto ${selected ? "border-gold shadow-[0_0_24px_rgba(204,148,64,0.18)]" : "border-line hover:border-gold/40"}`}
    >
      <div className="relative h-28 overflow-hidden">
        <img src={VEHICLE_IMAGES[vehicle.id]} alt={vehicle.model} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-surface via-surface/20 to-transparent" />
        {selected && (
          <span className="absolute right-3 top-3 flex h-7 w-7 items-center justify-center rounded-full bg-gold text-ink">
            <Check className="h-4 w-4" strokeWidth={2.5} />
          </span>
        )}
      </div>
      <div className="p-4 pt-2">
        <p className="font-display text-lg leading-tight text-ivory">{vehicle.name}</p>
        <p className="text-xs text-mist">{vehicle.model}</p>
        <div className="mt-3 flex items-center justify-between text-xs">
          <span className="flex items-center gap-1.5 text-mist">
            <Users className="h-3.5 w-3.5" /> Up to {vehicle.capacity}
          </span>
          <span className="text-gold">
            {hourly ? `${money(vehicle.per_hour)}/hr` : "Flat & distance rates"}
          </span>
        </div>
        <p className="mt-2 line-clamp-2 text-[11px] leading-relaxed text-faint">{vehicle.description}</p>
      </div>
    </button>
  );
}
